export default {
  APPCODE: 'PROCESS',
  reDemand: "Lặp lại yêu cầu ",
  noData: "Không có bản ghi nào",
  EmptyData: "Chưa có dữ liệu",
  search: "Tìm kiếm...",
  FeaturesIsDeveloping: "Tính năng đang phát triển",
  GetProcess: "Tiếp nhận kiến nghị",
  RepProcess: "Trả lời kiến nghị",
  command: {
    add: "Thêm",
    edit: "Sửa",
    update: "Cập nhật",
    delete: "Xóa",
    deleteField: "Xóa thông tin",
    duplicate: "Nhân bản",
    more: "Thêm nữa...",
    save: "Lưu",
    saveNew: "Lưu & Thêm",
    close: "Đóng",
    hide: "Ẩn",
    help: "Giúp",
    cancel: "Hủy",
    accept: "Đồng ý",
    saveAndNew: "Lưu và thêm mới",
    confirm: "Xác nhận",
    notConfirm: "Không xác nhận",
    export: "Xuất khẩu",
    finish: "Hoàn thành",
    load: "Nạp",
    print: "In",
    filter: "Lọc",
    refresh: "Nạp",
    setting: "Thiết lập",
    default: "Mặc định",
    list: "Danh sách",
    addDetail: "Thêm dòng",
    addDetailShortKey: "Thêm dòng (F9)",
    import: "Nhập khẩu",
    logout: "Đăng xuất",
    changePassword: "Đổi mật khẩu",
    next: "Tiếp theo",
    cancel: "Hủy",
    back: "Quay lại",
    move: "Di chuyển",
  },
  List: {
    SearchEmptyText: "Tìm kiếm",
  },
  module: {
    employee: "Nhân viên",
  },

  /*App đề xuẩt*/
  NameApp: "quy trình ",
  Confirm: "Xác nhận",
  Cancel: "Hủy",
  Cancel2: "Hủy bỏ",
  Close: "Đóng",
  Save: "Lưu",
  SendRequest: "Lập yêu cầu",
  SendRequestEMISNCL: "Lập yêu cầu - Tư thục",
  SendRequestEMISCL: "Lập yêu cầu - Công lập",
  DoubleCheck: "Kiểm tra lại",
  NoSave: "Không lưu",
  SaveSuccess: "Lưu thành công",
  DeleteSuccess: "Xoá thành công",
  SaveSetting: "Lưu thiết lập",
  Send: "Gửi",
  SaveAdd: "Lưu và Thêm",
  SaveAdd2: "Lưu & Thêm",
  SaveDraff: "Lưu nháp",
  SaveClose: "Cất và Đóng",
  Feature: "Chức năng",
  Replication: "Nhân bản",
  Delete: "Xóa",
  DeleteAll: "Xóa tất cả",
  Delete2: "Loại bỏ",
  FromDate: "Bắt đầu",
  ToDate: "Kết thúc",
  Agree: "Đồng ý",
  Forward: "Chuyển tiếp",
  Return: "Trả về",
  Implement: "Thực hiện",
  Add: "Thêm",
  AddNew: "Thêm mới",
  AddUser: "Thêm người dùng",
  AddNewCondition: "Thêm điều kiện",
  Finish: "Hoàn thành",
  SendRequest: "Lập yêu cầu",
  Back: "Quay lại",
  From: "Từ",
  To: "Đến",
  Edit: "Sửa",
  INVALID_DATE_SELECTED: "Giá trị từ ngày phải nhỏ hơn đến ngày",
  Edit2: "Chỉnh sửa",
  EditGroup: "Chỉnh sửa nhóm",
  Preview: "Xem trước",
  Yes: "Có",
  No: "Không",
  Show: "Có hiển thị",
  NotShow: "Không hiển thị",
  Help: "Giúp",
  Search: "Tìm kiếm",
  SearchDot: "Tìm kiếm...",
  Empty: "Trống",
  NotEmpty: "Không trống",
  Date: "Ngày",
  Month: "Tháng",
  Year: "Năm",
  Quarter: "Quý",
  Stage: "Kỳ",
  DataEmpty: "Không có dữ liệu",
  ExpandAll: "Mở rộng tất cả",
  CollapseAll: "Thu gọn tất cả",
  Update: "Cập nhật",
  Next: "Tiếp theo",
  Import: "Nhập khẩu",
  Export: "Xuất khẩu",
  Refresh: "Tải lại",
  Choose: "Chọn",
  SelectAllPage: "Chọn tất cả trang",
  SelectAll: "Chọn tất cả",
  StartDate: "Từ ngày",
  EndDate: "Đến ngày",
  Apply: "Áp dụng",
  Other: "Khác",
  Selected: "Đã chọn",
  UnSeclected: "Bỏ chọn",
  Filter: "Bộ lọc",
  Continue: "Tiếp tục",
  FirstTextDelete: "Bạn có chắc chắn muốn xóa ",
  WantSaveData: "Bạn có muốn lưu lại các thông tin vừa nhập không?",
  LastTextDelete: " không?",
  Removed: "Loại bỏ",
  Notify: "Thông báo",
  ConnectSuccess: "Kết nối thành công",
  ConnectFail: "Kết nối thất bại",
  Print: "In",
  Warning: "Cảnh báo",
  NotSend: "Chưa gửi",
  Waiting: "Chờ xử lý",
  Approved: "Đã xử lý",
  Reject: "Từ chối",
  SelectFile: "Chọn tệp",
  SelectOthesFile: "Chọn tệp khác",
  ConfimSave: "Thông tin đã được thay đổi. Bạn có muốn lưu lại không?",
  DoNotSave: "Không lưu",
  Ignore: "Bỏ qua",
  All: "Tất cả",
  YesUpdate: "Có, cập nhật",
  Download: "Tải xuống",
  AppConfig: {
    AppCode: "Payroll",
    AppName: "Tính lương",
  },
  ContentConfirm: "Bạn có muốn lưu lại các thông tin vừa nhập không?",
  Done: "Xong",
  Line: "Dòng",
  CannotDeleteAdmin: "Bạn không thể xóa quản trị hệ thống",
  ValidateEmplty: " không được để trống",
  Setting: "Thiết lập",
  SelectOrganizationUnit: "Chọn đơn vị",
  ShowOrganizationUnitInactive: "Hiển thị đơn vị ngừng theo dõi",
  ShowJobPositionInactive: "Hiển thị vị trí ngừng theo dõi",
  Detail: "Chi tiết",
  Unpaid: "Chưa thanh toán",
  Paid: "Đã thanh toán",
  FeedBack: "Phản hồi",
  Note: "Ghi chú",
  ChangeState: "Chuyển trạng thái",
  Excel: "Excel",
  PDF: "PDF",
  Total: "Tổng",
  Desc: "Giảm dần",
  Asc: "Tăng dần",
  OrderBy: "Sắp xếp theo",
  Sort: "Sắp xếp",
  GetDefault: "Lấy lại mặc định",
  Default: "Mặc định",
  Connect: "Kết nối",
  CancelConnect: "Hủy kết nối",
  Understand: "Đã hiểu",
  Disconnect: "Ngắt kết nối",
  SeeMore: "Xem thêm",
  LoadingData: "Đang lấy dữ liệu . . .",
  NoData: "Không có dữ liệu",
  NoData2: "Chưa có dữ liệu",
  NoPermission: "Bạn không có quyền thực hiện chức năng này",
  SendEmailError: "Không thể gửi Email do lỗi kết nối cấu hình Email",
  AllUnit: "Tất cả đơn vị",
  TitleRoute: {
    RequestSupport: "Yêu cầu thiết lập",
    RequestDisconnect: "Yêu cầu ngắt kết nối",
    ProcessExecution: "Kiến nghị",
    ProcessAll: "Tất cả",
    ProcessSended: "Tôi đã gửi",
    Executed: "Tôi đã thực hiện",
    ProcessNeedToDo: "Tôi cần thực hiện",
    ProcessRelatedMe: "Liên quan đến tôi",
    ProcessDraft: "Nháp",
    ProcessConfig: "Thiết kế quy trình ",
    Search: "Tra cứu",
    Report: "Báo cáo",
    Setting: "Thiết lập",
    Employee: "Nhân viên",
    Category: "Danh mục",
    // ProcessAll: "Tất cả lượt chạy",
    Process: "Quy trình ",
  },
  Contain: "Chứa",
  NotContain: "Không chứa",
  Equal: "Bằng",
  StartSwith: "Bắt đầu bằng",
  EndSwith: "Kết thúc bằng",
  Other: "Khác",
  Smaller: "Nhỏ hơn",
  SmallerOrEqual: "Nhỏ hơn hoặc bằng",
  Higher: "Lớn hơn",
  HigherOrEqual: "Lớn hơn hoặc bằng",
  ToDay: "Hôm nay",
  ThisWeek: "Tuần này",
  ThisMonth: "Tháng này",
  ThisYear: "Năm nay",
  Yesterday: "Hôm qua",
  PreviousWeek: "Tuần trước",
  PreviousMonth: "Tháng trước",
  PreviousYear: "Năm trước",
  ThisQuarter: "Quý này",
  PreviousQuarter: "Quý trước",
  FirstSixMonth: "6 tháng đầu năm",
  LastSixMonth: "6 tháng cuối năm",
  Tomorrow: "Ngày mai",
  NextWeek: "Tuần sau",
  NextMonth: "Tháng sau",
  NextYear: "Năm sau",
  Between: "Trong khoảng",
  between: "trong khoảng",
  CancelFilter: "Bỏ lọc",
  AdjustColumns: "Tùy chỉnh cột",
  AllEmployees: "Tất cả các nhân viên",
  None: "Rỗng",
  Table: "Bảng",
  RestoreDefault: "Lấy lại mặc định",
  ConfigTable: "Cấu hình bảng",
  SettingContruction: "Thiết lập cấu trúc",
  CompositionCode: "Mã thành phần",
  DisplayColumnName: "Tên cột hiển thị",
  GroupColumn: "Nhóm cột",
  NumberRecords: "Số bản ghi",
  Page: "trang",
  TotalRecords: "Tổng số bản ghi",
  Total: "Tổng số",
  Records: "bản ghi",
  Expand: "Mở rộng",
  Collapse: "Thu gọn",
  AdjustColumnsNotify: {
    DeleteAjustColumnNotify:
      "Bạn có chắc chắn muốn xóa cột <b>{Caption}</b> trên <b>{SubSystemCode}</b> này không ?",
    On: "trên",
    This: "này không",
    Addcolumns: "Thêm cột",
  },
  from: "từ",
  to: "đến",
  FormatExportFile: "Định dạng tệp xuất khẩu",
  AllColumn: "Tất cả cột",
  PinColumn: "Ghim cột",
  RemovePinColumn: "Bỏ ghim cột",
  Reference: "Tham chiếu",
  SearchSth: "Tìm kiếm khóa đào tạo, buổi đào tạo, học viên...",
  Download1: "Tải về",
  OrganizationUnit: "Cơ cấu tổ chức",
  OrganizationUnit2: "Đơn vị công tác",
  CreateRequest: "Tạo kiến nghị",
  PERMISSION: "Vai trò",
  PERMISSION_NAME: "Tên vai trò",
  PERMISSION_FIND_HINT: "Tìm kiếm vai trò",
  DESCRIPTION: "Mô tả",
  RequestDate: "Ngày tạo",
  PublishDate: "Ngày gửi",
  StepRequired: "Các bước thực hiện",
  date: "ngày",
  Approval: "Phê duyệt",
  RelatePerson: "Người liên quan",
  AddRelatePerson: "Thêm người liên quan",
  FileAttach: "Tệp đính kèm",
  SendRequest: "Lập yêu cầu",
  RemoveRequest: "Xóa yêu cầu",
  SendRequestFailed: "Lập yêu cầu thất bại",
  ResendRequestFailed: "Lập lại các yêu cầu thất bại",
  SpecificPerson: "Người cụ thể",
  DirectorManagerment: "Quản lý trực tiếp",
  Self_Select: "Người tạo tự chọn",
  Select_One: "Chọn một trong số",
  SendApproval: "Gửi kiến nghị",
  AgreeAndForward: "Đồng ý và chuyển tiếp",
  NextApprover: "Người thực hiện",
  Comment: "Bình luận",
  Email: "Email",
  Email: "Email người lập yêu cầu",
  ReasonForReject: "Lý do trả về",
  ReasonReasign: "Lý do phân công lại",
  ForwardReject: "Khi từ chối quy trình  sẽ chuyển về cho",
  EnterReasonReject: "Nhập lý do từ chối",
  ReasonReject: "Lý do trả về",
  UnderConstruction: "Chức năng đang thi công",
  SendRequestSuccess: "Đã lập thành công yêu cầu thiết lập cho {numberSchool} trường",
  SendRequestDisconnectSuccess: "Đã lập thành công yêu cầu ngắt kết nối cho {numberSchool} trường",
  ApprovalSuccess: "Phê duyệt thành công",
  ConfirmApproval:
    "Bạn là người thực hiện cuối. Xác nhận Đồng ý và hoàn tất quy trình",
  DraftSucess: "Lưu nháp thành công",
  RequestInfo: "Thông tin quy trình ",
  NewPassword: "Mật khẩu mới",
  OldPassword: "Mật khẩu cũ",
  ConfirmPassword: "Nhập lại mật khẩu mới",

  ERROR_COMPANY_LIST: "Danh sách trường không được để trống",
  POPUP_SETTING_REQUEST_FORM_TITLE: "Thiết lập mẫu",
  POPUP_SETTING_REQUEST_FORM_FIELD: "Trường thông tin",
  POPUP_SETTING_REQUEST_FORM_FIELD_DESCRIPTION:
    "Kéo thả trường thông tin sang phải để thiết lập bước.",
  POPUP_SETTING_REQUEST_FORM_EMPTY_STATE:
    "Kéo và thả hoặc nhấp chuột vào các nút bấm ở bên phải để tạo biểu mẫu",
  POPUP_SETTING_REQUEST_FORM_FIELD_DEFAULT1: "Ghi chú",
  POPUP_SETTING_REQUEST_FORM_FIELD_DEFAULT2: "Người liên quan",
  POPUP_SETTING_REQUEST_FORM_FIELD_DEFAULT3: "Tài liệu đính kèm",
  PU_INPUT_FORM_CONFIG_TITLE: "Trường thông tin",
  PU_INPUT_FORM_CONFIG_INPUTNAME: "Tên trường",
  PU_INPUT_FORM_CONFIG_DUPLICATE_INPUTNAME: "Tên trường đã tồn tại",
  PU_INPUT_FORM_CONFIG_SELECT_DATA: "Giá trị",
  PU_INPUT_FORM_CONFIG_SELECT_DATA_MULTI: "Danh sách lựa chọn",
  PU_INPUT_FORM_CONFIG_DESIGN_TABLE: "Thiết kế bảng ",
  PU_INPUT_FORM_CONFIG_SELECT_ADD_DATA: "Thêm dòng",
  PU_INPUT_FORM_CONFIG_SELECT_DATA_DEFAULT: "Giá trị ngầm định",
  PU_INPUT_FORM_CONFIG_SHOW_DESCRIPTION: "Hiển thị hướng dẫn",
  PU_INPUT_FORM_CONFIG_SHOW_GUIDE_PLACEHOLDER: "Nhập nội dung hướng dẫn",
  PU_INPUT_FORM_CONFIG_SHOW_DESCRIPTION_PLACEHOLDER: "Nhập nội dung mô tả",
  PU_INPUT_FORM_CONFIG_IS_REQUIRED: "Là trường bắt buộc",
  PU_FORM_CONFIG_TYPE_SINGLE_LINE: "Một dòng",
  PU_FORM_CONFIG_TYPE_DOCUMENT: "Văn bản",
  PU_FORM_CONFIG_TYPE_SHORT_DOCUMENT: "Văn bản ngắn",
  PU_FORM_CONFIG_TYPE_LONG_DOCUMENT: "Văn bản dài",
  PU_FORM_CONFIG_TYPE_Pick_People: "Người được chỉ định",

  PU_FORM_CONFIG_TYPE_LETTER: "Chữ",
  PU_FORM_CONFIG_TYPE_MULTI_LINE: "Nhiều dòng",
  PU_FORM_CONFIG_TYPE_SINGLE_SELECT: "Chọn một",
  PU_FORM_CONFIG_TYPE_MULTI_SELECT: "Chọn nhiều",
  PU_FORM_CONFIG_TYPE_DATE: "Ngày tháng",
  PU_FORM_CONFIG_TYPE_DATETIME: "Ngày giờ",
  PU_FORM_CONFIG_TYPE_NUMBER: "Số",
  PU_FORM_CONFIG_TYPE_DECIMAL: "Số thập phân",
  PU_FORM_CONFIG_TYPE_CHECKBOX: "Tích chọn",
  PU_FORM_CONFIG_TYPE_ORGANIZATION: "Tổ chức",
  PU_FORM_CONFIG_TYPE_EMPLOYEE: "Nhân viên",
  PU_FORM_CONFIG_TYPE_UPLOAD_IMAGE: "Ảnh",
  PU_FORM_CONFIG_TYPE_UPLOAD_FILE: "Tệp đính kèm",
  PU_FORM_CONFIG_TYPE_LOAD_FILE: "Tải tệp",
  PU_FORM_CONFIG_TYPE_UPLOAD_VIDEO: "Video",
  PU_FORM_CONFIG_TYPE_UPLOAD_SUBTASKS: "Công việc con",
  PU_FORM_CONFIG_TYPE_TABLE: "Bảng",
  PU_FORM_CONFIG_TYPE_UPLOAD_LISTSTEP: "Trường từ bước trước",
  PU_FORM_CONFIG_TYPE_SELECT_PERSON: "Chọn người",
  PU_FORM_CONFIG_TYPE_CONTENT: "Nội dung hiển thị",
  PU_FORM_CONFIG_TYPE_FORM: "Biểu mẫu nhập liệu",

  ERROR_CHECKBOX_REQUIRED: "Bạn phải chọn ít nhất 1 giá trị",
  ERROR_EMPLOYEES_REQUIRED: "Bạn cần chọn ít nhất 1 nhân viên",
  ERROR_EMPLOYEE_REQUIRED: "Vui lòng chọn Người thực hiện",
  ERROR_RADIO_REQUIRED: "Bạn cần chọn ít nhất 1 giá trị",
  ERROR_UPLOAD_FILE_REQUIRED: "Bạn cần tải lên tài liệu đính kèm",
  REQUEST_FORM_PREVIEW_TITLE: "Mẫu thông tin quy trình ",
  REQUEST_FORM_PREVIEW_DESCRIPTION:
    "Khi tạo quy trình  với loại quy trình  này cần cung cấp những thông tin dưới đây",
  REQUEST_FORM_PREVIEW: "Đây là mẫu thông tin xem trước",
  REQUEST_FORM_PREVIEW_EDIT: "Sửa mẫu",
  REQUEST_FORM_PREVIEW_EMPTY_STATE: "Chưa thiết lập mẫu thông tin quy trình ",
  REQUEST_FORM_PREVIEW_SETTING: "Thiết lập mẫu",
  PU_SETTING_REQUEST_EXECUTION_NAME_TITLE: "Thiết lập tiêu đề cho quy trình ",
  PU_SETTING_REQUEST_EXECUTION_NAME_DESCRIPTION:
    "Tiêu đề sẽ tự động sinh ra khi người dùng chạy loại quy trình  này",
  MIXED_FIELD_REQUEST_NAME: "Tên loại quy trình ",
  MIXED_FIELD_REQUEST_CREATED_DATE: "Ngày tạo quy trình ",
  MIXED_FIELD_REQUEST_CREATED_BY: "Người tạo quy trình ",
  EditSuccess: "Chỉnh sửa thành công",
  EditFailed: "Chỉnh sửa thất bại",
  DeleteSuccess: "Xóa thành công",
  Activity: "Hoạt động",
  Approver: "Người duyệt",
  EnterComment: "Viết bình luận...",
  COMMENT: "Bình luận",
  POPUP_SELECT_SYMBOL_TITLE: "Chọn biểu tượng",
  POPUP_SELECT_SYMBOL_FROM_LIBRARY: "Chọn từ thư viện",
  POPUP_SELECT_SYMBOL_UPLOAD_FROM_DESKTOP: "Tải lên từ máy",
  POPUP_SELECT_SYMBOL_DROP_DRAG_IMAGE: "Kéo thả ảnh để tải lên hoặc",
  POPUP_SELECT_SYMBOL_IMAGE: "chọn ảnh",
  POPUP_SELECT_SYMBOL_IMAGE_2: "Chọn ảnh khác",
  POPUP_SELECT_SYMBOL_VALIDATE_IMAGE:
    "Hỗ trợ tệp có định dạng: jpg, png. Dung lượng tối đa 200KB.",
  POPUP_SELECT_SYMBOL_VALIDATE_FILE_SIZE: "Dung lượng tối đa 200KB.",
  VALIDATE_FILE_NOT_VALID: "Định dạng file không hợp lệ",
  ADD_REQUEST_TYPE: "Tạo quy trình ",
  EDIT_REQUEST_TYPE: "Sửa loại quy trình ",
  DUPLICATE_REQUEST_TYPE: "Nhân bản loại quy trình ",
  PROCESS_TYPE_NAME: "Tên quy trình ",
  REQUEST_GROUP: "Nhóm",
  PROCESS_STEP: "Các bước thực hiện ",
  REQUEST_ADD_PERSON: "+ Thêm người",
  REQUEST_ADD_GUIDE: "+ Thêm hướng dẫn",
  REQUEST_NEW: "Tạo mới quy trình ",
  COMPLETE: "Hoàn thành",
  COMPLETED: "Đã hoàn thành",
  PERMISSION_TO_USE: "Phân quyền sử dụng",
  PROCESS_TIME: "Thời hạn xử lý",
  SYMBOL: "Biểu tượng",
  STATUS: "Trạng thái",
  ACTIVE: "Đang hoạt động",
  NOT_ACTIVE: "Ngừng hoạt động",
  TIME_MINUTE_AGO: "phút trước",
  TIME_HOUR_AGO: "giờ trước",
  TIME_JUST_NOW: "Vừa xong",
  TIME_DAY_AGO: "ngày trước",
  TIME_WEEK_AGO: "tuần trước",
  CREATE_REQUEST: "tạo mới quy trình ",
  SEND_REQUEST: "đã tạo mới quy trình ",
  REJECTED_REQUEST: "đã Từ chối quy trình ",
  CANCELED_EXECUTION: "đã Hủy bỏ quy trình ",
  APPROVED_EXECUTION: "đã Đồng ý quy trình ",
  EDIT_EXECUTION: "đã chỉnh sửa thông tin",
  CREATED_BY: "Người tạo",
  CREATED_DATE: "Ngày tạo",
  JOB_POSITION: "Vị trí",
  ORGANIZTIONUNIT: "Phòng ban",
  POPUP_SETTING_REQUEST_FORM_AUTO_GENERATE_FIELD_DESCRIPTION:
    "Các thông tin này được tự động sinh ra theo từng lượt chạy",
  VIEW_DETAIL: "xem chi tiết",
  VIEW_REASON: "xem lý do",
  AddPeople: "Thêm người",
  ChoosePeople: "Chọn người",
  NOT_HAVE_ACTIVITY_YET: "Chưa có hoạt động nào",
  NOT_HAVE_COMMENT_YET: "Chưa có bình luận nào",
  NOT_HAVE_ACTIVITY_YET: 'Chưa có nhật ký hoạt động nào',
  DeleteComment: "Xóa bình luận",
  DeleteCommentContent: "Bạn có chắc muốn xóa bình luận này không?",
  EDIT_FROM: "sửa từ",
  EDIT_TO: "thành",
  NO_DATA_VALUE: "giá trị trống",
  SHOW_LESS: "Thu gọn",
  WAITING_APPROVE: "Chờ xem xét",
  EDIT_REQUEST: "Sửa quy trình ",
  DeleteRequest: "Xóa quy trình ",
  DeleteRequestContent: "Bạn có chắc chắn muốn xóa quy trình  này không?",
  AgreeDeleteRequest: "Có, xóa quy trình ",
  CancelRequest: "Hủy quy trình ",
  CancelRequestContent:
    "quy trình  đang chờ xem xét, bạn có chắc chắn muốn hủy quy trình  không?",
  AgreeCancelRequest: "Có, hủy quy trình ",
  CancelEditRequest: "Hủy bỏ chỉnh sửa",
  CancelEditRequestContent:
    "Các chỉnh sửa vừa thực hiện sẽ không được lưu. Bạn có chắc chắn muốn hủy bỏ không?",
  CancelCreateRequestContent:
    "Bạn có chắc chắn muốn hủy bỏ quy trình  đang tạo?",
  AgreeCancelEditRequest: "Hủy bỏ",
  PageNotFoundTitle: "Oops! Không tìm thấy trang",
  FoundText: "Tìm thấy",
  ProcessLowerCase: "kiến nghị",
  HasSameConentText: "có nội dung tương tự đã được trả lời.",
  CheckBeforeSendingText: "Bạn có thể kiểm tra trước khi gửi",
  HereText: "tại đây",
  ToSendProcess: "để gửi kiến nghị.",
  PageNotFoundSubTitle:
    "Đường dẫn đang truy cập đã bị thay đổi hoặc không tồn tại",
  BackHome: "Quay lại trang chủ",

  PU_SELECT_REQUEST_FORM_LIBRARY: "Thêm loại quy trình  chọn từ thư viện",
  PU_SELECT_REQUEST_FORM_LIBRARY_DESCRIPTION:
    "Bạn có thể tạo loại quy trình  từ những thư viện có sẵn bên dưới",
  PU_SELECT_REQUEST_FORM_LIBRARY_BUTTON_USE: "Sử dụng mẫu này",
  CancelSuccess: "Hủy quy trình  thành công!",
  col_Title: "Tiêu đề",
  col_Priority: "Mức độ ưu tiên",
  col_Owner: "Đối tượng kiến nghị",
  col_Status: "Trạng thái kiến nghị",
  col_OrgReply: "Đơn vị trả lời",
  col_RelatedToOrg: "Đơn vị phối hợp trả lời",
  col_Field: "Lĩnh vực",
  ExecutorName: "Người thực hiện",
  Executor: "Người thực hiện",
  AddCommentFailed: "Thêm bình luận thất bại!",
  COMPLETED: "Đã hoàn thành",
  REQUESTFAVOURITE: "Yêu thích",
  NOT_HAVE_REQUEST_TYPE_IN_GROUP: "Chưa có loại quy trình  nào trong nhóm này",
  PU_SETTING_AUTOMATION_TITLE: "Thiết lập quy trình",
  PU_SETTING_AUTOMATION_REQUEST_CATEGORY: "Loại quy trình ",
  PU_SETTING_ADVANCE_PROCESS: "Quy trình phê duyệt",
  PU_SETTING_AUTOMATION_EVENT: "Sự kiện",
  PU_SETTING_AUTOMATION_CONDITION_AND_ACTION: "Thiết lập điều kiện rẽ nhánh",
  PU_SETTING_AUTOMATION_ACTION_DESCRIPTION:
    "Quy trình  mặc định đi tuần tự theo các bước trong Quy trình xử lý, trừ các trường hợp được thiết lập theo điều kiện dưới đây",
  PU_SETTING_AUTOMATION_DECLINE_DESCRIPTION: "Hành động khi từ chối quy trình ",
  PU_SETTING_AUTOMATION_IF: "Nếu",
  PU_SETTING_AUTOMATION_THEN: "Thì",
  PU_SETTING_AUTOMATION_NEXT_STEP: "Chuyển bước",
  PU_SETTING_AUTOMATION_COMPLETE: "Hoàn thành",
  PU_SETTING_AUTOMATION_END: "Kết thúc quy trình",
  PU_SETTING_AUTOMATION_SEND_REQUEST: "Gửi kiến nghị",
  SHOW_MORE_COMMENT: "Xem thêm bình luận",
  LIKE: "Thích",
  REPLY: "Trả lời",
  AGREE: "Đồng ý",
  UPLOAD_FILE: "Tải tệp lên",
  DROP_DRAG_FILE: "Kéo thả tệp để tải lên",
  OR: "hoặc",
  SELECT_FILE: "chọn tệp",
  POPUP_SELECT_VALIDATE_FILE_TYPE:
    "Hỗ trợ các định dạng: word, excel, ppt, pdf, png, jpeg",
  POPUP_SELECT_VALIDATE_FILE_VOVLUME: "Dung lượng tối đa 2 MB",
  SELECT_OTHER: "Chọn tệp khác",
  UPLOAD_FAILED: "Lỗi tải tệp",
  VALIDATE_FILE_INVALID_VOLUME: "Tệp vượt quá dung lượng cho phép",
  EDITED: "Đã chỉnh sửa",
  HISTORY_EDIT_COMMENT: "Lịch sử chỉnh sửa bình luận",
  NOT_SELECTED: "- Không chọn -",
  DELETE_ATTACH: "Xóa file đính kèm",
  POPUP_ADD_STEP_REQUEST_STEPNAME: "Tên bước",
  POPUP_ADD_STEP_REQUEST_TABLE: "Tên bảng",
  POPUP_ADD_STEP_REQUEST_STEPNAME_ADD_STEP: "Thêm bước",
  POPUP_ADD_STEP_REQUEST_STEPNAME_EDIT: "Sửa bước",
  POPUP_ADD_STEP_REQUEST_STEPNAME_VALIDATE: "Tên bước đã tồn tại",
  POPUP_ADD_STEP_REQUEST_STEPNAME_SELECT_EXECUTER:
    "Vui lòng chọn người thực hiện",
  POPUP_ADD_STEP_REQUEST_STEPNAME_GUIDE: "Hướng dẫn chọn",
  POPUP_ADD_STEP_REQUEST_STEPNAME_ADD_NEW: "Lưu và thêm mới",
  POPUP_ADD_STEP_REQUEST_STEPNAME_ADD_EXECUTER: "Thêm người thực hiện",
  POPUP_ADD_STEP_REQUEST_SELF_SELECT: "Người dùng tự chọn",
  POPUP_ADD_STEP_REQUEST_SPESIFIC_PERSON: "Người cụ thể",
  POPUP_ADD_STEP_REQUEST_SELECT_ONE: "Chọn một trong số",
  POPUP_ADD_STEP_REQUEST_USER_GROUP: "Nhóm trong ứng dụng",
  POPUP_ADD_STEP_REQUEST_ONE_OF_MANY: "Nhiều người thực hiện đồng thời",
  POPUP_ADD_STEP_REQUEST_UNLIMITED_TIME: "Không có thời hạn",
  POPUP_ADD_STEP_REQUEST_LIMITED_TIME: "Có thời hạn",
  PREVIEW_DIAGRAM: "Xem sơ đồ",
  RETRY: "Thử lại",
  REQUEST_EXPIRE: "quy trình  đã hết hạn!",
  RELOAD_DATA: "Tải lại dữ liệu",
  RELOAD: "Tải lại",
  CONTENT_CONFIRM_RELOAD:
    "Không thể lưu do quy trình  đã bị thay đổi bởi người dùng khác. Vui lòng tải lại!",
  USER: "Người dùng",
  REQUEST_SUPPORT: "Danh sách yêu cầu thiết lập thanh toán",
  REQUEST_DISCONNECT: "Danh  sách yêu cầu ngắt kết nối thanh toán",
  USER_GROUP: "Nhóm người dùng",
  SEARCH_USER: "Tìm kiếm người dùng",
  ADD_USER_STEP_ONE: "Bước 1 : Thêm người dùng",
  SEARCH_BY_NAME_EMAIL_LOCATION: "Tìm kiếm theo tên, email, vị trí",
  ADD_USER_STEP_TWO: "Bước 2 : Chọn vai trò",
  EDIT_USER: "Sửa người dùng",
  WAIT_FOR_CONFIRMATION: "Chờ xác nhận",
  DEACTIVATION: "Ngừng kích hoạt",
  JOB_INFORMATION: "THÔNG TIN CÔNG VIỆC",
  EMPLOYEE_CODE: "Mã nhân viên",
  ORGANIZATION_UNIT_NAME: "Đơn vị công tác",
  JOB_POSITION_NAME: "Vị trí công việc",
  ROLE_INFORMATION: "THÔNG TIN PHÂN QUYỀN",
  GENERAL_INFORMATION: "THÔNG TIN CHUNG",
  ROLE_NAME: "Tên vai trò",
  ENTER_ROLE_NAME: "Nhập tên vai trò",
  ENTER_DESCRIPTION: "Nhập mô tả",
  DECENTRALIZATION_SUBSYSTEM: "PHÂN QUYỀN PHÂN HỆ",
  CHOOSE_ROLE: "Chọn quyền",
  DECENTRALIZATION_SETTING: "PHÂN QUYỀN THIẾT LẬP",
  ALL_REQUEST: "Tất cả",
  MY_ALL_REQUEST: "Của tôi",
  THIS_ROLE_HAS_BEEN_USERD: "Vai trò này đã được sử dụng !",
  DELETE_ROLE: "Xóa vai trò",
  THIS_ROLE: "vai trò này",
  DELETE_ROLE_SUCCESSFUL: "Xóa vai trò thành công !",
  AN_ERROR_OCCURRED: "Đã xảy ra lỗi !",
  ROLE_NAME_ALREADY_EXISTS: "Tên vai trò đã tồn tại !",
  ROLE_NAME_CANNOT_BE_EMPTY: "Tên vai trò không được để trống !",
  FULLNAME: "Họ và tên",
  EMAIL: "Tài khoản email",
  ADD_USER_SUCCESSFULLY: "Thêm người dùng thành công.",
  UPDATE_USER_SUCCESSFULLY: "Cập nhật người dùng thành công.",
  DELETE_USER: "Xóa người dùng",
  FROM_THE_RECOMMENDED_AMIS_APPLICATION: "khỏi ứng dụng AMIS quy trình ",
  DELETE_USER_SUCCESSFUL: "Xóa người dùng thành công.",
  CHOOSE_PERMISSION: "Chọn vai trò",
  NOTE_PLACEHOLDER: "Nhập nội dung....",
  TITLE: "Tiêu đề",
  REQUEST_TYPE: "Loại quy trình ",
  USER_POSITION: "Vị trí của người tạo",
  USER_ORGANIZTIONUNIT: "Phòng ban của người tạo",
  DURATION: "Thời hạn",
  POPUP_CONFIRM_DELETE_REQUEST_TYPE_TITLE: "Xóa loại quy trình ",
  POPUP_CONFIRM_DELETE_REQUEST_TYPE:
    "Bạn có chắc muốn xóa loại quy trình  <strong>{RequestCategoryName}</strong> không?",
  POPUP_CONFIRM_DELETE_REQUEST_TYPE_NOT:
    "Có <strong>{CountRequest}</strong> lượt chạy thuộc <strong>{RequestCategoryName}</strong> đang trong quá trình thực hiện. Bạn không thể xóa loại quy trình  này.",
  DRAFT: "Nháp",
  PUBLIC: "Đồng ý",
  EXPRIED: "Hết hạn",
  REJECT_AND_FINISH: "Từ chối và kết thúc",
  PENDING: "Chờ xem xét",
  CHOOSE_TIME: "Tùy chọn",
  POPUP_MANAGER_GROUP_REQUEST_TYPE: "Quản lý nhóm quy trình ",
  POPUP_MANAGER_GROUP_REQUEST_TYPE_ADD: "Thêm nhóm",
  POPUP_MANAGER_GROUP_REQUEST_TYPE_ADD_SUCCESS:
    "Thêm nhóm quy trình  thành công",
  POPUP_MANAGER_GROUP_REQUEST_TYPE_UPDATE_SUCCESS:
    "Cập nhật nhóm quy trình  thành công",
  POPUP_MANAGER_GROUP_REQUEST_TYPE_DELETE: "Xóa nhóm quy trình ",
  POPUP_MANAGER_GROUP_REQUEST_TYPE_GROUP: "nhóm quy trình ",
  POPUP_MANAGER_GROUP_REQUEST_TYPE_NOT_DELETE:
    "Bạn không thể xóa nhóm quy trình  này.",
  POPUP_MANAGER_GROUP_REQUEST_TYPE_RT_GROUP: "loại quy trình  thuộc nhóm",
  POPUP_MANAGER_GROUP_REQUEST_TYPE_CURENTLY_AVAILABLE: "Hiện đang có",
  POPUP_MANAGER_GROUP_REQUEST_TYPE_DELETE_SUCCESS:
    "Xóa nhóm quy trình  thành công",
  POPUP_ADD_REQUEST_TYPE_GROUP_NAME: "Tên nhóm",
  POPUP_ADD_REQUEST_TYPE_GROUP: "Thêm nhóm",
  POPUP_ADD_REQUEST_TYPE_GROUP_EDIT: "Chỉnh sửa nhóm",
  CHECK_DUPLICATE: "{FieldName} đã tồn tại trên hệ thống",
  REQUEST_REJECTED: "Đã từ chối",
  REJECTED: "Bị từ chối",
  RESEND_FAIL: 'Không còn trường thất bại cần thiết lập.<br> Các trường thất bại đã được thiết lập thành công ở những yêu cầu khác.',
  CANCELED_REQUEST: "Đã hủy",
  JOB_GROUP_NAME: "Nhóm vị trí",
  JOB_TITLE_NAME: "Chức danh",
  LABEL_REASSIGNMENT: "Cho phép phân công lại",
  DETAIL_LABEL_REASSIGNMENT:
    "Cho phép chọn lại Người thực hiện ở bước đang chờ xem xét",
  REASSIGN: "Phân công lại",
  LABEL_REASSIGN_EXECUTOR: "Người tiếp nhận",
  ENTER_REASSIGN_EXECUTOR: "Chọn người tiếp nhận lại",
  LABEL_REASON_REASSIGN: "Lý do phân công lại",
  ENTER_REASON_REASSIGN: "Nhập lý do",
  VIEW_STATISTIC_DETAIL: "Xem thống kê chi tiết",
  CHART_REQUEST_CREATED: "Số quy trình  đã tạo",
  SUB_CHART_REQUEST_CREATED: "Không bao gồm các quy trình  nháp",
  RATE_BY_STATE: "Tỷ lệ theo trạng thái",
  STATISTIC_BY_REQUEST_TYPE: "Thống kê theo loại quy trình ",
  REQUEST_EXECUTED_AMOUNT: "Số lượt thực hiện",
  SUB_RREQUEST_EXECUTED_AMOUNT: "Tính số lượt thực hiện Đồng ý hoặc Từ chối",
  RATE_BY_RESULT: "Tỷ lệ theo kết quả",
  ALL_TIME: "Tất cả thời gian",
  FROM_DATE_MUST_TO_LESS_THAN_TO_DATE:
    "Từ ngày phải nhỏ hơn hoặc bằng đến ngày",
  TO_DATE_IS_NOT_REQUIRED: "Đến ngày không được bỏ trống",
  Expired: "Còn hạn",
  UnExpired: "Quá hạn",
  Personal: "Cá nhân",
  Unit: "Đơn vị",
  REASSIGNED_EXECUTION: "đã phân lại cho",
  REASSIGN_SUCCESS: "Phân công lại thành công!",
  REASON: "Lý do",
  NOTFOUND_USER:
    "Không có Người tiếp nhận hợp lệ. Vui lòng liên hệ với Quản trị ứng dụng để được hỗ trợ",
  RESEND_REQUEST: "đã gửi lại quy trình ",
  ALL_EMPLOYEE: "Tất cả nhân viên",
  HOUR: "Giờ",
  MANAGER_GROUP: "Quản lý nhóm",
  ADD_REQUEST_GROUP: "Thêm nhóm quy trình ",
  SELECT_STEP: "Chọn bước",
  SELECT_ACTION: "Chọn hành động",
  ACTIVITY_LOG: "Nhật ký hoạt động",
  LIST_PROCESS: "Danh sách quy trình",
  SELECT_PROCESS_TO_CONTINUE: "Chọn một loại quy trình để tiếp tục",
  CREATE_PROCESS: "Tạo quy trình",
  CREATE_BY_ME: "Tạo bởi",
  IN_PROGRESS: "Đang xử lý",
  STEPEXECUTIONNAME: "Công việc",
  PROCESS_CODE: "Mã lượt",
  PROCESS_PUBLISH_DATE: "Ngày gửi",
  PROCESS_DEADLINE: "Thời hạn trả lời",
  PROCESS_FIELD: "Lĩnh vực",
  PROCESS_OWNER: "Đối tượng kiến nghị",
  STEP_EXECUTION_NAME: "Công việc",
  PROCESS_CONFIG_NAME: "Loại kiến nghị",
  STEPS_PROCESS: "Các bước thực hiện",
  DeleteProcessExcution: "Xóa kiến nghị",
  DeleteProcessExcutionContent: "Bạn có chắc muốn xóa kiến nghị này không?",
  ProcessExcution: "Kiến nghị <span>{processExcutionTitle}</span>",
  InProcess: "Cần thực hiện",
  WaitingProcess: "Chờ thực hiện",
  Sended: "Đã gửi",
  ProcessApproval: "Đã thực hiện",
  ProcessRelated: "Liên quan",
  Status: "Trạng thái",
  Draft: "Nháp",
  Processing: "Đang xử lý",
  ReturnStep: "Trả về bước",
  NextStep: "Chuyển đến bước",
  Reassignment: "Phân công lại",

  SendAction: "đã gửi kiến nghị",
  AgreeAction: "đã đồng ý kiến nghị",
  ForwardAction: "đã chuyển tiếp kiến nghị",
  RejectedAction: "đã từ chối kiến nghị",
  ReturnAction: "đã trả về kiến nghị",
  ReassignAction: "đã phân công lại kiến nghị cho",
  DataChangeAction: "đã sửa thông tin kiến nghị",

  Reason: 'Lý do',
  Reassignment: "Phân công lại",
  DeleteGroupUserError: "Không thể xóa nhóm người dùng của hệ thống",

  LOW: "Thấp",
  NORMAL: "Vừa",
  HIGHT: "Cao",

  ReportTerm: "Kỳ báo cáo",
  FromText: "Từ",
  ToText: "Đến",
  RequestList: {
    AllPetition: "Danh sách kiến nghị",
    PetitionByField: "Tổng hợp kiến nghị theo lĩnh vực",
    PetitionByUnitRequest: "Tổng hợp kiến nghị theo đơn vị gửi kiến nghị",
    PetitionByUnitAnswer: "Tổng hợp kiến nghị theo đơn vị trả lời",
    PetitionByStatus: "Tổng hợp kiến nghị theo trạng thái trả lời",
  },
  CurrentYear: "Năm nay",
  AllRequests: "Tất cả kiến nghị",
  PersonalText: "Cá nhân",
  UnitText: "Đơn vị",
  NotRead: "Chưa đọc",
  NotifyEmpty: "Chưa có thông báo nào.",
  ChartReplyStatus: "Cơ cấu kiến nghị theo tình trạng trả lời",
  ChartField: "Cơ cấu kiến nghị theo lĩnh vực",
  ChartOrgOwner: "Cơ cấu kiến nghị theo đơn vị gửi kiến nghị",
  ChartOrgReply: "Cơ cấu kiến nghị đã trả lời theo đơn vị trả lời ",
  OtherField: "Lĩnh vực khác",
  OtherOrg: "Đơn vị khác",
  Answered: "Đã trả lời",
  NonAnswered: "Chưa trả lời",
  Rejected: "Bị trả lại"
};
